let year = new Date()?.getFullYear();
export const SHIFT_TIME_CONST = 19;
export const NO_PERMISSION_MESSAGE = "You don't have permission to access this.Please contact your administrator.";
export const MONTH_DATA = [
    { label: "Jan", value: 1, year: year },
    { label: "Feb", value: 2, year: year },
    { label: "Mar", value: 3, year: year },
    { label: "Apr", value: 4, year: year },
    { label: "May", value: 5, year: year },
    { label: "Jun", value: 6, year: year },
    { label: "Jul", value: 7, year: year },
    { label: "Aug", value: 8, year: year },
    { label: "Sep", value: 9, year: year },
    { label: "Oct", value: 10, year: year },
    { label: "Nov", value: 11, year: year },
    { label: "Dec", value: 12, year: year }
]
export const OPEN_KEY_DATA2 = [
    { openKey: "faq-management", path: ["faqs", "faq-category"] },
    { openKey: "user-management", path: ["users", "roles",] }
]
export const OPEN_KEY_DATA = [
    { openKey: [], selected: ["hip"], path: "" },
    { openKey: [], selected: ["dashboard"], path: "dashboard" },
    { openKey: [], selected: ["settings"], path: "settings" },
    { openKey: [], selected: ["organizations"], path: "organizations" },
    { openKey: [], selected: ["organizations"], path: "organization-add" },
    { openKey: [], selected: ["organizations"], path: "organization-edit" },
    { openKey: [], selected: ["testmanagement"], path: "test-management" },
    { openKey: [], selected: ["ticket-management"], path: "ticket-management" },
    { openKey: ['user-management'], selected: ["users"], path: "users" },
    { openKey: ['user-management'], selected: ["users"], path: "user-list" },
    { openKey: ['user-management'], selected: ["users"], path: "user-add" },
    { openKey: ['user-management'], selected: ["users"], path: "user-edit" },
    { openKey: ['user-management'], selected: ["roles"], path: "roles" },
    { openKey: ['user-management'], selected: ["roles"], path: "role-list" },
    { openKey: ['user-management'], selected: ["roles"], path: "role-add" },
    { openKey: ['user-management'], selected: ["roles"], path: "role-edit" },
    { openKey: ['user-management'], selected: ["roles"], path: "role-user-permission" },
    { openKey: [], selected: ["ticket-management"], path: "ticket-management" },
    { openKey: ['ticket-management'], selected: ["ticket-management"], path: "ticket-management-add" },
    { openKey: ['ticket-management'], selected: ["ticket-management"], path: "ticket-management-edit" },
    { openKey: [], selected: ["hip"], path: "hip-dashboard" },
    { openKey: [], selected: ["HIU Dashboard"], path: "hiu-dashboard" },
    { openKey: ['hip"'], selected: ["hip"], path: "abha-linked" },  
    { openKey: ['hip"'], selected: ["hip"], path: "abha-linked-log" }, 
    { openKey: ['hip"'], selected: ["hip"], path: "hip-log" },
    { openKey: ['hip"'], selected: ["hip"], path: "hip-user-inisiated" },
    { openKey: ['hip'], selected: ["hip"], path: "hip-consent-grant" },
    { openKey: ['hip'], selected: ["hip"], path: "hip-data-request-received" },
    { openKey: ['hip'], selected: ["hip"], path: "hip-data-shared" },
    { openKey: ['hip'], selected: ["hip"], path: "hip-data-request-pending" },
    { openKey: ['HIU Dashboard'], selected: ["HIU Dashboard"], path: "hiu-consent-artifact-requested" },
    { openKey: ['HIU Dashboard'], selected: ["HIU Dashboard"], path: "hiu-consent-grant" },
    { openKey: ['HIU Dashboard'], selected: ["HIU Dashboard"], path: "hiu-consent-artifact-details" },
    { openKey: ['HIU Dashboard'], selected: ["HIU Dashboard"], path: "hiu-helath-information-requested" },
    { openKey: ['HIU Dashboard'], selected: ["HIU Dashboard"], path: "hiu-data-received" },
    { openKey: ['HIU Dashboard'], selected: ["HIU Dashboard"], path: "hiu-data-request-pending" },
    { openKey: ['abdm'], selected: ["abdm"], path: "abdm-report-requested" },
    { openKey: ['abdm'], selected: ["abdm"], path: "abdm-report-received" },
    { openKey: ['abdm'], selected: ["abdm"], path: "abdm-ask-report" },
    { openKey: ['abdm'], selected: ["abdm"], path: "abdm-report-detail" },


]